import { AutoUnsubscribe } from '../../../decorators';
import { ListClientPaginationStateModel } from '../../../models';
import { AfterViewInit, Directive } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../../constants';
import { List } from './list';
import { TranslateService } from '@ngx-translate/core';

@Directive()
@AutoUnsubscribe
export abstract class ListClientPagination<BriefType> extends List<BriefType> implements AfterViewInit {
  protected constructor(translateService: TranslateService) {
    super(translateService);
  }
  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  protected updateTable(tableDto: ListClientPaginationStateModel<BriefType>): void {
    this.dataSource = new MatTableDataSource(tableDto.items);
    this.initPaginator();
  }

  protected initPaginator(): void {
    this.paginator.pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS;
    this.paginator.pageSize = DEFAULT_PAGE_SIZE;
    this.paginator.pageIndex = DEFAULT_PAGE_INDEX;
    this.dataSource.paginator = this.paginator;
  }
}
